export default __webpack_public_path__ + "static/media/split.6bebcca0.svg";